import { DateTime, IANAZone } from "luxon"
import { CalendarDate, parseDate } from "@internationalized/date"

/**
 * Specify whether or not a time zone value is a valid IANA identifier.
 */
export function isValidTimeZone(timeZone: string) {
  return IANAZone.isValidSpecifier(timeZone) && IANAZone.isValidZone(timeZone)
}

/**
 * Ensure date is a valid DateTime before it is converted to @internationalized/date.
 */
export function sanitizeDateValue(timeZone: string, date?: DateTime | null) {
  if (date != null) {
    return date.isValid ? fromLuxonDateToInternationalizedDate(date, timeZone) : null
  }
  return date
}

/**
 * Converts Luxon date to Internationalized date. Time zone is considered.
 */
export function fromLuxonDateToInternationalizedDate(
  input: DateTime,
  timeZone: string,
): CalendarDate {
  const { year, month, day } = input
  const luxonDate = DateTime.local(year, month, day, { zone: timeZone })
  return parseDate(luxonDate.toISODate())
}

/**
 * Converts Internationalized date to Luxon date. Time zone is considered.
 */
export function fromInternationalizedDateToLuxonDate(
  input: CalendarDate,
  timeZone: string,
): DateTime {
  const { year, month, day } = input
  return DateTime.local(year, month, day, { zone: timeZone })
}

/**
 * Returns a list of years. Start and end years inclusive
 * @param start
 * @param end
 * @returns number[]
 */
export function getYearRange(start: number, end: number): number[] {
  const yearRange = []
  let currentValue = start

  while (currentValue <= end) {
    yearRange.push(currentValue)
    currentValue = currentValue + 1
  }

  return yearRange
}
